import { createContext, useState, useEffect, useContext } from 'react';
import logger from 'utils/logger';

const log = logger.createLogger('AppUpdateProvider');

const AppUpdateContext = createContext({});

const BUILD_VERSION = import.meta.env.VITE_APP_VERSION;
const publicUrl = import.meta.env.VITE_PUBLIC_URL || '';
const isLocal = import.meta.env.VITE_ENV === 'local';
// Remove trailing slash if present
const cleanPublicUrl = publicUrl.replace(/\/$/, '');
const VERSION_FILE_URL = cleanPublicUrl + '/version.json';
const CHECK_INTERVAL = 1000 * 60 * 5; // Check every 5 minutes

const AppUpdateProvider = ({ children }) => {
  const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);
  useEffect(() => {
    if (isLocal) return;
    const checkVersion = async () => {
      try {
        const response = await fetch(VERSION_FILE_URL, { cache: 'no-store' }); // bypass browser cache
        const data = await response.json();

        if (data.version && data.version !== BUILD_VERSION) {
          // A new version is available!
          log.warn(
            `New version available. Please refresh. ${data.version} !== ${BUILD_VERSION}`
          );
          setIsUpdateAvailable(true);
        }
      } catch (error) {
        log.error('Failed to check for new version:', error);
      }
    };

    const intervalId = setInterval(checkVersion, CHECK_INTERVAL);

    // Initial check when the component mounts
    checkVersion();

    return () => clearInterval(intervalId);
  }, []);
  return (
    <AppUpdateContext.Provider
      value={{ isUpdateAvailable, setIsUpdateAvailable }}>
      {children}
    </AppUpdateContext.Provider>
  );
};

export const useAppUpdate = () => {
  return useContext(AppUpdateContext);
};

export default AppUpdateProvider;
